import React from "react";
import {
  EditBase,
  SimpleForm,
  TextInput,
  BooleanInput,
  useNotify,
  useRedirect,
  useUpdate
} from "react-admin";
import Box from "@mui/material/Box";

const ActionEdit: React.FC = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [update] = useUpdate();

  const handleSave = async (data: any) => {
    try {
      await update("permissionActions", { id: data.id, data });
      notify("Action Updated", { type: "info" });
      redirect("list", "permissionActions");
    } catch (error) {
      notify("Update Failed", { type: "error" });
    }
  };

  return (
    <EditBase resource="permissionActions">
      <SimpleForm sx={{ backgroundColor: "#ffffff", p: 3 }} onSubmit={handleSave}>
        <Box display="flex" flexWrap="wrap" gap={2}>

          <Box flex="1 1 48%">
            <TextInput source="actionName" label="Action Name" fullWidth />
          </Box>

          <Box flex="1 1 48%">
            <TextInput source="actionCode" label="Action Code" fullWidth />
          </Box>

          <Box flex="1 1 48%">
            <BooleanInput source="enabled" label="Enabled" />
          </Box>

          <Box flex="1 1 100%">
            <TextInput source="description" label="Description" fullWidth multiline rows={3} />
          </Box>

        </Box>
      </SimpleForm>
    </EditBase>
  );
};

export default ActionEdit;
